// AUTO-GENERATED by tools/codegen (pnpm gen). Do not edit. Source: apps/client/src/game/interactions/*.ts
import * as m0 from './interactions/board';
import * as m1 from './interactions/dig';
import * as m2 from './interactions/door';
import * as m3 from './interactions/fish';
import * as m4 from './interactions/mailbox';
import * as m5 from './interactions/museum';
import * as m6 from './interactions/pickUp';
import * as m7 from './interactions/plant';
import * as m8 from './interactions/remove';
import * as m9 from './interactions/shake';
import * as m10 from './interactions/shell';
import * as m11 from './interactions/shop';
import * as m12 from './interactions/villager';
import * as m13 from './interactions/yardTidy';
export const interactionModules = [m0, m1, m2, m3, m4, m5, m6, m7, m8, m9, m10, m11, m12, m13] as const;
